<app-phx-card
    class="w-full"
    #phxCardProduct
    [spaceBetween]="true"
    [fullWidth]="true"
    [borderLeftColor]="borderLeftColor()"
    [cardMinHeight]=""
    [showAssetLoader]="showAssetLoader(assetModel || getAsset())"
    [showInnerDataLoader]="showInnerDataLoader()"
>
    <ng-template #assetArea>
        <div class="product-asset-img">
            <app-widget-asset-preview
                #assetWidget
                [editable]="product()?.id"
                [asset]="assetModel || getAsset()"
                (selectFiles)="onFilesSelected($event)"
                [dataTestId]="'product-header-card'"
                (onDelete)="onDelete.emit($event)"
            />
        </div>
    </ng-template>
    <ng-template #innerData>
        @if (product()) {
            <div class="flex flex-col relative">
                @if (product()?.id) {
                    <div class="absolute top-0 right-0">
                        <app-base-model-info-widget
                            [detailModel]="product()"
                            tooltipPosition="left"
                            [preInfoItems]="[
                                {
                                    label: 'common.createdByEmployee',
                                    value: getCreatorEmployeeInfo.bind(this)
                                }
                            ]"
                        />
                    </div>
                }
                <!-- Identifier and Group in one line -->
                <div class="flex flex-wrap">
                    <span
                        *ngIf="this.product().identifier && !this.loadingSig(); else newProduct"
                        class="mb-0 text-2xl font-semibold"
                        [innerHtml]="insertBreakAtDot(this.product()?.identifier)"
                    ></span>

                    <p-badge
                        styleClass="ml-1 text-xs"
                        *ngIf="product().primaryProductGroup?.identifier"
                        [value]="product().primaryProductGroup.identifier | truncate"
                        icon="fa fa-user"
                        pTooltip="{{
                            product().primaryProductGroup.description ||
                                'product.primary-product-group' | translate
                        }}"
                    ></p-badge>

                    <!-- Display variantFacetValues as badges -->
                    <ng-container
                        *ngIf="
                            product().variantFacetValues && product().variantFacetValues.length > 0
                        "
                    >
                        <p-badge
                            *ngFor="let facetValue of product().variantFacetValues"
                            styleClass="ml-1 text-xs"
                            [value]="facetValue.identifier"
                            severity="secondary"
                            icon="fa fa-tag"
                            pTooltip="{{
                                (facetValue.facet.description || facetValue.facet.identifier) +
                                    ': ' +
                                    (facetValue.description || facetValue.identifier)
                            }}"
                        ></p-badge>
                    </ng-container>
                </div>

                <span
                    *ngIf="this.product().description && !this.loadingSig()"
                    [innerHtml]="insertBreakAtDot(this.product()?.description)"
                >
                </span>
                <span
                    *ngIf="this.product().productType && !this.loadingSig()"
                    class="text-slate-400 flex"
                    [pTooltip]="'product.product-type' | translate"
                >
                    {{ 'enums.' + this.product().productType | translate }}
                    @if (this.product().variantParent) {
                        ({{ 'product.variant-of' | translate }}&nbsp;
                        <a
                            class="text-slate-400 hover:text-primary"
                            [routerLink]="getProductEditLink(this.product().variantParentId)"
                            >{{ this.product().variantParent?.identifier | truncate }}</a
                        >)
                    }
                </span>
                <ng-template #newProduct>
                    <span class="mb-0 text-2xl font-semibold">
                        {{ 'product.new-product' | translate }}
                    </span>
                </ng-template>
            </div>
        }
    </ng-template>
    <ng-template #buttons></ng-template>
</app-phx-card>
